import React from 'react';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

import './information-obligation-page.base.scss';

const InformationObligationBase: React.FC = () => (
    <section>
        <h1>PRZETWARZANIE DANYCH OSOBOWYCH – OBOWIĄZEK INFORMACYJNY</h1>
        <ul className="information-obligation__list">
            <li className="information-obligation__item">
                <h2 className="information-obligation__title">W JAKICH CELACH PRZETWARZAMY DANE?</h2>
                <p>
                    Przetwarzamy Twoje dane osobowe w celu zawarcia i wykonania umowy zawieranej z
                    Tobą (Użytkownikiem) w oparciu o treść niniejszego Regulaminu. Dane podajesz
                    dobrowolnie, jednakże są one konieczne w celu prawidłowej realizacji Usługi, jaką Ci
                    świadczymy i w zakresie niezbędnym do jej wykonania.
                </p>
            </li>

            <li className="information-obligation__item">
                <h2 className="information-obligation__title">KTO ADMINISTRUJE TWOJE DANE?</h2>
                <p>
                    Zaakceptowany przez Ciebie regulamin naszego serwisu skapiec.pl lub wyrażone zgody
                    są prawną podstawą przetwarzania Twoich danych przez <strong>administratora</strong> danych, czyli
                    podmiot decydujący o tym jak Twoje dane osobowe będą wykorzystywane, tj. <strong>Ringier
                    Axel Springer Polska sp. z o.o. z siedzibą w Warszawie</strong> (02-672), ul. Domaniewska 52
                    (dalej w niniejszym załączniku: „my”). Nasze pełne dane znajdziesz w definicji
                    Skąpiec/Administratora/Usługodawcy (w Art. 2 pkt 1 Regulaminu).
                </p>
            </li>

            <li className="information-obligation__item">
                <h2 className="information-obligation__title">JAK KONTAKTOWAĆ SIĘ Z ADMINISTRATOREM?</h2>
                <p>
                    <strong>Nasze dane kontaktowe to:</strong>
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- ul. Curie-Skłodowskiej 12 we Wrocławiu (50-381)
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- <a href="mailto:skapiec@skapiec.pl">skapiec@skapiec.pl</a>
                </p>
                <br />
                <p>
                    Nasz Inspektor Ochrony Danych Osobowych:
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- email: <a href="mailto:ido@ringieraxcelspringer.pl">ido@ringieraxcelspringer.pl</a>
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- adres korespondencyjny: Ringier Axel Springer Polska sp. z o.o., ul. CurieSkłodowskiej 12, 50-381 Wrocław.
                </p>
            </li>

            <li className="information-obligation__item">
                <h2 className="information-obligation__title">SKĄD MAMY TWOJE DANE?</h2>
                <p>
                    Twoje dane otrzymaliśmy od Ciebie w celu prawidłowego wykonania Umowy
                    (świadczenia Usługi określonej niniejszym Regulaminem). Wymagamy podania nam
                    Twoich danych rejestracyjnych:
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- Przy zamawianiu Alertu Cenowego wymagamy podania <strong>adresu e-mail;</strong>
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- O ile nasz Serwis udostępnia funkcjonalność dodawania Wypowiedzi – możemy
                    wymagać podawania adresu e-mail do takiej usługi.
                </p>
            </li>
        </ul>

        <ul className="information-obligation__list">
            <li className="information-obligation__item">
                <h2>Kwestie techniczne</h2>
                <br />
                <p>
                    Jeżeli korzystasz z dowolnej witryny internetowej, aplikacji mobilnej, czy usługi
                    internetowej, niektóre informacje są automatycznie generowane i rejestrowane
                    (wynika to z ogólnych zasad połączeń realizowanych w Internecie). Do takich
                    informacji można zaliczyć:
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- dane urządzenia, z którego korzystasz (np. rodzaj i wersja przeglądarki
                    internetowej i jej tzw. „user agent”, typ urządzenia: komputer, urządzenie
                    mobilne typu smartfon)
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- inne dane techniczne (tzw. „dane eksploatacyjne”), wynikające z logowań,
                    aktywności lub z tzw. „plików dziennika” (informacje, które zapisują serwery, w
                    tym wysyłane automatycznie przez Twoją przeglądarkę lub aplikację mobilną),
                </p>
            </li>
        </ul>

        <ul className="information-obligation__list">
            <li className="information-obligation__item">
                <p>
                    Są to informacje zwyczajowo zbierane przez administratorów stron internetowych
                    (charakteryzują sposób korzystania z usługi świadczonej drogą elektroniczną lub służą
                    zbieraniu ogólnych, statystycznych informacji).
                    <br /><br />W Serwisie skapiec.pl, wraz z danymi rejestracyjnymi (np. adres e-mail z
                    formularzy), również przetwarzamy informacje zebrane podczas Twojej aktywności w
                    Serwisie – są to np. adresy IP, przeglądane lub wyszukiwane strony naszego serwisu,
                    kliknięcia, czas korzystania z określonych usług Serwisu, sposób, w jaki korzystasz z
                    Serwisu, przeglądarka internetowa i informacje o urządzeniu.
                    <br /><br />Gromadzimy i wykorzystujemy powyższe informacje głównie w celach technicznych
                    związanych z administracją naszymi serwerami, do zbierania ogólnych, statystycznych
                    informacji demograficznych, lokalizacyjnych (np. o regionie, z którego następuje
                    połączenie), a także do potrzeb analizowania rynku, czy zachowań i preferencji
                    Użytkowników, na potrzeby polepszenia jakości naszych usług.
                </p>
            </li>

            <li className="information-obligation__item">
                <h2 className="information-obligation__title">
                    JAKI MAMY CEL, GDY DANE PRZETWARZAMY NA PODSTAWIE UMOWY
                    {' '}<span className="information-obligation__title-text">(ZAAKCEPTOWANEGO PRZEZ CIEBIE REGULAMINU)</span>
                </h2>

                <p>
                    Po to by wykonać dla Ciebie prawidłowo umowę (świadczenia usług określonych
                    naszym regulaminem), przetwarzamy Twoje dane osobowe, które nam podałeś przez
                    nasz formularz (np. przy zamawianiu usługi Alert Cenowy) lub podczas korzystania z
                    Serwisu (np., gdy zaktualizujesz dane z formularza). Przetwarzanie Twoich danych jest
                    nam niezbędne do zawarcia i wykonania zawartej z Tobą umowy w oparciu o treść
                    niniejszego Regulaminu, a także do:
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- umożliwienia świadczenia usługi drogą elektroniczną oraz pełnego korzystania z
                    Serwisu lub rozwiązywania problemów technicznych w naszych usługach.
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- obsługi zgłoszeń, w tym reklamacji, które nam wysyłasz przez formularz
                    kontaktowy lub listownie,
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- powiadamiania Cię i kontaktowania się z Tobą w celach związanych ze świadczoną
                    usługą.
                </p>
                <br />
                <p>
                    Dane podajesz dobrowolnie, jednakże są one konieczne w celu prawidłowej realizacji
                    Usługi, jaką Ci świadczymy i w zakresie niezbędnym do jej wykonania.
                </p>
                <br />
                <p>
                    Dane przetwarzane w celu realizacji umowy(Regulaminu) przetwarzamy przez czas jej
                    realizacji i w okresie przedawnienia roszczeń z tytułu umowy/świadczenia usług, w tym
                    roszczeń organów publicznych (podatkowych) do momentu wygaśnięcia obowiązku
                    przechowywania danych wynikającego z przepisów prawa.
                </p>
            </li>

            <li className="information-obligation__item">
                <h2 className="information-obligation__title">
                    JAKI MAMY tzw. PRAWNIE UZASADNIONY INTERES BY PRZETWARZAĆ TWOJE DANE?
                </h2>

                <p>
                    MARKETING WŁASNY. Podejmujemy niezbędne dla nas działania by nasz Serwis i jego
                    zawartość były dla Ciebie interesujące. W naszym uzasadnionym interesie następuje
                    przetwarzanie danych w celu marketingowym własnym (wraz z niezbędną analityką
                    lub zestawianiem w tzw. profile marketingowe). To przetwarzanie odbywa się w
                    oparciu o Twoje dane osobowe, które wprowadzasz do Serwisu za pomocą
                    dedykowanego formularza do ich podawania lub podczas ich edycji wraz z zebranymi
                    informacjami o Twojej aktywności w serwisach lub innych funkcjonalnościach
                    (aplikacjach, skryptach) podmiotów grupy kapitałowej, do której należymy (np.
                    przeglądane strony, kliknięcia, sposób w jaki korzystasz z usług). W wyniku tych działań
                    proponujemy lepiej dostosowaną do Ciebie zawartość Serwisu (np. wyświetlamy Ci
                    dopasowane kategorie tematyczne Serwisu, które mogą Cię zaciekawić). Mamy także
                    uzasadniony interes w organizacji konkursów lub akcji promocyjnych naszych usług, w
                    których możesz wziąć udział albo w bieżącym promowaniu usług naszego Serwisu, z
                    których możesz skorzystać.
                </p>
            </li>

            <li className="information-obligation__item">
                <p>
                    Przechowujemy Twoje dane osobowe dla celów marketingowych w okresie
                    obowiązywania umowy(regulaminu) lub do momentu Twojego sprzeciwu na takie
                    przetwarzanie, w zależności od tego, które z tych zdarzeń wystąpi wcześniej.
                </p>
                <br />
                <p>
                    Krótko ujmując – te działania są dla nas niezbędne, aby Serwis był dla Ciebie
                    interesujący – działamy zarówno w Twoim, jak i w naszym interesie.
                </p>
                <br />
                <p>
                    ANALIZY I STATYSTYKA. Stale rozwijamy Serwis, zapoznajemy się z nadsyłanymi do nas
                    opiniami Użytkowników o aktualnych usługach lub funkcjonalnościach oraz potrzebie
                    zmian. Ponieważ takie zmiany dotyczą wszystkich korzystających z naszego Serwisu
                    musimy mierzyć i analizować informacje wynikające z aktywności w Serwisie by
                    sprostać oczekiwaniom Użytkowników. Naszym uzasadnionym interesem jest bieżące
                    prowadzenie badań/analiz danych i statystyk Serwisu oraz jego usług lub
                    funkcjonalności w celu poprawy jakości ich działania bądź dla uwzględniania głównych
                    potrzeb odwiedzających Serwis. W tym celu możemy też monitorować aktywność
                    Użytkowników, taką jak popularność wyszukiwanych słów kluczowych (np. danej
                    kategorii tematycznej lub danego rodzaju produktu).
                </p>
                <br />
                <p>
                    ROZLICZALNOŚĆ. W prawnie uzasadnionym interesie przechowujemy niezbędne dane
                    dla celów archiwizacyjnych oraz zapewniania tzw. rozliczalności przetwarzania, tj.
                    wykazania spełniania przez nas obowiązków, jakie nakładają na nas przepisy prawa.
                    Przechowujemy te dane przez okres, w którym jesteśmy zobowiązani do zachowania
                    danych lub dokumentów je zawierających, o ile są niezbędne do udokumentowania
                    przestrzegania przez nas wymagań prawnych i kontroli ich spełniania przez organy
                    publiczne.
                </p>
            </li>

            <li className="information-obligation__item">
                <h2 className="information-obligation__title">RZETWARZANIE DANYCH ZA TWOJĄ ZGODĄ</h2>
                <p>
                    W trakcie korzystania z Serwisu możesz udzielić dobrowolnie dodatkowej zgody na
                    przetwarzanie Twoich danych w celach innych niż te, które wskazaliśmy wyżej.
                </p>
                <br />
                <p>
                    Po uzyskaniu Twojej zgody przetwarzamy Twoje dane osobowe w celu i w zakresie
                    wskazanym w treści tej zgody, do czasu, aż ją odwołasz. Udzielona przez Ciebie zgoda
                    jest prawną podstawą przetwarzania Twoich danych - zachowujesz prawo do jej
                    odwołania w każdym momencie – za pomocą naszych narzędzi do jej odwołania (np. w
                    ustawieniach Konta) lub kontaktując się z nami na wskazany adres listowny lub
                    elektroniczny.
                </p>
                <br />
                <p>
                    Możesz zgodzić się na przetwarzanie przez nas Twoich danych osobowych:
                </p>
                <br />
                <p>
                    - w celach marketingowych
                    <br /><br />(to takie działania jak: promowanie (reklamy) ofert usług i produktów
                    dopasowanych do Twoich zainteresowań, zgodnie z Twoją uprzednią aktywnością
                    bądź organizacja konkursów lub akcji promocyjnych)
                </p>
                <br />
                <p>
                    - otrzymywania informacji handlowych
                    <br /><br />(to takie działania jak: przesyłanie Ci dopasowanych do Twoich zainteresowań
                    informacji o ofertach i promocjach usług lub produktów naszych Zaufanych
                    Partnerów) na e-mail przypisany do Konta, wewnętrzną pocztę (funkcjonalność
                    Serwisu) lub w ramach usługi wewnętrznego komunikatora.
                </p>
            </li>
        </ul>

        <ul>
            <li className="information-obligation__item">
                <p>
                    MARKETING NASZYCH ZAUFANYCH PARTNERÓW. Jeżeli wyrazisz zgodę dla
                    powyższych celów - Twoje dane podane w dedykowanym formularzu do ich
                    podawania lub podczas ich edycji oraz zebrane informacje o Twojej aktywności
                    w serwisach lub innych funkcjonalnościach (aplikacje, skrypty) podmiotów z
                    grupy kapitałowej, do której należymy (przeglądane strony, kliknięcia, sposób w
                    jaki korzystasz z serwisów, w tym niezbędna analityka, zestawianie w profile
                    marketingowe) wykorzystujemy do prezentowania Ci reklam produktów i usług
                    naszych Zaufanych Partnerów.
                </p>
                <br />
                <p>
                    Przetwarzamy Twoje dane osobowe w powyższy sposób dopóki nie wycofasz zgody –
                    możesz swoją zgodę odwołać w każdym momencie.
                </p>
            </li>

            <li className="information-obligation__item">
                <h2 className="information-obligation__title">TWOJE PRAWA</h2>
                <p>
                    Wraz z podaniem swoich danych osobowych przysługują Ci uprawnienia wynikające z
                    obowiązujących przepisów prawa (rozporządzenia o ochronie danych - tzw.
                    „RODO”), także w przypadku prawidłowego przetwarzania Twoich danych, tj.
                </p>

                <br />
                <h3 className="information-obligation__subtitle">§ prawo dostępu, sprostowania</h3>
                <p>
                    Ze sprostowania danych skorzystasz, gdy zauważysz, że Twoje dane
                    są nieprawidłowe lub niekompletne.
                </p>

                <br />
                <h3 className="information-obligation__subtitle">§ prawo do usunięcia Twoich danych</h3>
                <p>
                    Z usunięcia danych skorzystasz m.in., gdy:
                    <br />- Twoje dane osobowe będą zbędne do celów, dla których zostały przez
                    nas zebrane,
                    <br />- cofniesz swoją zgodę na przetwarzanie danych
                    <br />- zgłosisz nam sprzeciw wobec przetwarzania Twoich danych
                    <br />- Twoje dane są przetwarzane niezgodnie z prawem,
                    <br />- Twoje dane osobowe powinny być usunięte wobec obowiązku wynikającego
                    z przepisu prawa
                </p>

                <br />
                <p>
                    Jeżeli wnioskujesz o usunięcie Twoich danych osobowych, a są one niezbędne do
                    Usługi, którą dla Ciebie realizujemy i tym samym konieczne do wykonania umowy –
                    Twój wniosek o usunięcie danych jest równoznaczny z Twoim oświadczeniem o
                    rozwiązaniu umowy(regulamin). Po zrealizowaniu wniosku nie skorzystasz z
                    Serwisu i jego usług w dotychczasowym zakresie, gdyż jest to niemożliwe z
                    przyczyn technicznych i w związku z tym uprawnieni będziemy do usunięcia bądź
                    anonimizacji Twoich komentarzy dostarczonych do Serwisu.
                </p>

                <br />
                <h3 className="information-obligation__subtitle">§ prawo ograniczenia ich przetwarzania</h3>
                <p>
                    Z ograniczenia przetwarzania skorzystasz m.in., gdy:
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- zauważysz, że Twoje dane są nieprawidłowe i zażądasz od nas ograniczenia ich
                    przetwarzania na okres niezbędny do sprawdzenia prawidłowości tych danych,
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- Twoje dane byłyby przetwarzane niezgodnie z prawem, ale zechcesz ich nie
                    usuwać,
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- Twoje dane będą dla nas zbędne, ale Tobie mogą być potrzebne do obrony
                    lub dochodzenia roszczeń
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- wniesiesz sprzeciw wobec przetwarzania danych – na czas ustaleń, czy nasze
                    prawnie uzasadnione podstawy są nadrzędne wobec podstaw Twojego
                    sprzeciwu
                </p>

                <br />
                <h3 className="information-obligation__subtitle">§ prawo do przenoszenia Twoich danych osobowych</h3>
                <p>
                    Skorzystasz z tego prawa w zakresie, w jakim Twoje dane przetwarzamy w celu
                    realizacji umowy(Regulaminu) lub przetwarzamy na podstawie Twojej
                    odrębnej zgody.
                </p>

                <br />
                <h3 className="information-obligation__subtitle">
                    § niepodleganie zautomatyzowanemu podejmowaniu decyzji, w tym
                    profilowaniu wywołującemu skutki prawne względem Ciebie lub w podobny
                    sposób znacząco na Ciebie wpływając
                </h3>

                <p>
                    Na naszych stronach personalizujemy zawartość Serwisu – jego treści, reklamy i
                    funkcjonalności (np. polecimy Ci podobne podstrony Serwisu, zaproponujemy
                    możliwość skorzystania z naszej funkcjonalności/usługi - np. Alertu Cenowego), a
                    także korzystamy z segmentów zainteresowań w celach marketingowych. Nie
                    podejmujemy działań polegających na profilowaniu (w tym też w sposób
                    zautomatyzowany), które wywoływałyby wobec Ciebie jakiekolwiek skutki
                    prawne, a także istotnie wpływałyby w podobny sposób na Twoją sytuację.
                </p>

                <br />
                <h3 className="information-obligation__subtitle">§ prawo do sprzeciwu</h3>
                <p>
                    Z sprzeciwu skorzystasz, gdy przetwarzamy Twoje dane osobowe:
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- na podstawie naszego prawnie uzasadnionego interesu lub dla celów
                    statystycznych, a sprzeciw jest uzasadniony Twoją szczególną sytuacją,
                    <br />&nbsp;&nbsp;&nbsp;&nbsp;- na potrzeby marketingu bezpośredniego, w tym z profilowaniem dla tego celu.
                </p>

                <br />
                <p>
                    Masz też prawo złożyć skargę do organu nadzorczego ochrony danych osobowych.
                </p>

                <br />
                <h3>JAK SKORZYSTAĆ Z UPRAWNIEŃ?</h3>
                <br />
                <p>
                    W celu realizacji praw i otrzymania dodatkowych informacji możesz skorzystać z
                    <br />- naszych danych kontaktowych, które wskazaliśmy Ci wyżej
                    <br />- dostępnych w Serwisie narzędzi – w tym na stronie zlokalizowanej pod adresem:
                    {' '}
                    <a
                        rel={SeoLinkRelEnum.NOOPENER_NOREFERRER}
                        target={LinkTarget.BLANK}
                        href="https://zgody.skapiec.pl/"
                    >
                        https://zgody.skapiec.pl/
                    </a>
                </p>
            </li>

            <li className="information-obligation__item">
                <h2 className="information-obligation__title">PRZEKAZYWANIE DANYCH (NASI PODWYKONAWCY)</h2>
                <p>
                    Jeżeli przy przetwarzaniu danych skorzystamy z usług dodatkowych podmiotów (np.
                    dostawców usług IT, podwykonawców tzw. hostingu), powierzenie danych następuje
                    zgodnie z naszym poleceniem wynikającym z umowy z takim podmiotem.
                </p>
            </li>

            <li className="information-obligation__item">
                <h2 className="information-obligation__title">POZOSTAŁE INFORMACJE</h2>
                <p>
                    Pozostałe informacje dotyczące przetwarzania znajdziesz w Załączniku nr 2 do
                    Regulaminu, w którym zamieściliśmy odnośniki do podstron ze stosownymi
                    szczegółowymi informacjami, tj. do Polityki Prywatności i stosowania w jej ramach
                    technologii cookie lub podobnej.
                </p>

                <br />
                <p>
                    Informacje o działaniu naszej aplikacji mobilnej znajdziesz w Załączniku nr 5
                    Regulaminu (art. 7 Załącznika nr 5).
                </p>

                <br />
                <h3>Formularz kontaktowy – kontakt z Biurem Obsługi Klienta</h3>
                <br />
                <p>
                    Ponieważ prowadzimy serwis internetowy – zdajemy sobie sprawę, że niektóre
                    sformułowania używane w sieci Internet mogą być nieco skomplikowane, dlatego
                    staramy się wyjaśnić je w prosty sposób. Jeżeli masz pytania – skontaktuj się z nami na
                    nasz adres, który podaliśmy wyżej. Możliwość kontaktu mailowego z pracownikami
                    Biura Obsługi Klienta możliwa jest poprzez formularz dostępny na naszej stronie lub
                    pod adresem bok(małpa)skapiec.pl
                </p>

                <br />
                <p>
                    Przechowujemy korespondencję z naszymi Użytkownikami oraz gromadzimy dane
                    osobowe Użytkowników kontaktujących się z Biurem Obsługi Klienta w celach
                    statystycznych oraz jak najlepszej i najszybszej reakcji na pojawiające się zapytania, a
                    także w zakresie rozstrzygnięć reklamacyjnych i podejmowanych na podstawie
                    zgłoszeń ewentualnych decyzji o interwencjach administracyjnych we wskazane
                    funkcjonalności Serwisu. Jednocześnie zapewniamy, że adresy oraz dane w ten
                    sposób gromadzone nie będą wykorzystywane do komunikacji z Użytkownikiem w
                    celu innym niż realizacja zgłoszenia. Ewentualna komunikacja w innych kwestiach
                    może się odbywać tylko za uprzednią zgodą Użytkownika.
                </p>
            </li>
        </ul>
    </section>
);

export default InformationObligationBase;
